import http from "../redux/http";
import httpAuth from "../redux/httpAuth";

export const coreLoginAPI = async (credentials) => {
  try {
    const { data } = await httpAuth.post("/rest-auth/login/", credentials);
    return data;
  } catch ({ response }) {
    return response.data.non_field_errors[0];
  }
};

export const coreSignUpAPI = async (credentials) => {
  try {
    const { data } = await httpAuth.post(
      "/rest-auth/registration/",
      credentials
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const blogsLoginAPI = async (coreKey) => {
  try {
    const { data } = await http.post("/auth/login/", coreKey);
    return data;
  } catch (error) {
    return error;
  }
};

export const coreUserAPI = async (coreKey) => {
  try {
    const { data } = await httpAuth.get("/rest-auth/user/");

    return data;
  } catch (error) {
    return null;
  }
};

export const getUserDetails = async (id) => {
  return await http.get(`/users/${id}`);
};
